import React from "react";

const Footer = () => {
    const styles = {
        footer: {
            width: "100%",
            alignSelf: "center",
            justifyContent: "center",
            paddingBottom: 5,
            fontSize: 12,
            color: "#000000",
        },
        hyperLink: {
            color: "#000000"
        }
    };

    const currentyear = new Date().getFullYear();

    return(
        <div>
            <div style={styles.footer}>
                <p>
                    © 2019-{currentyear} untied | All rights reserved {" "} <br/>
                    <a
                        style={styles.hyperLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.untied.io/untied-privacy-policy/"
                    >
                        Privacy Policy
                    </a>{" "}
                    |{" "}
                    <a
                        style={styles.hyperLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.untied.io/untied-app-terms-conditions/"
                    >
                        Terms of Service
                    </a>
                </p>
            </div>
        </div>
    );
};

export default Footer
